import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { bonusApi } from '@/api/bonus.api';

export const bonusKeys = {
  all: ['bonus'] as const,
  list: () => [...bonusKeys.all, 'list'] as const,
  schedule: () => [...bonusKeys.all, 'schedule'] as const,
};

export function useBonusRules() {
  return useQuery({
    queryKey: bonusKeys.list(),
    queryFn: () => bonusApi.list(),
  });
}

export function useBonusSchedule() {
  return useQuery({
    queryKey: bonusKeys.schedule(),
    queryFn: () => bonusApi.getSchedule(),
  });
}

export function useCreateBonusRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bonusApi.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: bonusKeys.all });
      toast.success('Regla creada');
    },
    onError: () => toast.error('Error al crear regla'),
  });
}

export function useUpdateBonusRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dto }: { id: string; dto: Parameters<typeof bonusApi.update>[1] }) => bonusApi.update(id, dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: bonusKeys.all });
      toast.success('Regla actualizada');
    },
    onError: () => toast.error('Error al actualizar'),
  });
}

export function useRemoveBonusRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bonusApi.remove,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: bonusKeys.all });
      toast.success('Regla eliminada');
    },
    onError: () => toast.error('Error al eliminar'),
  });
}

export function useSetBonusMode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ mode, defaultPercent }: { mode: 'manual' | 'auto'; defaultPercent?: number }) =>
      bonusApi.setMode(mode, defaultPercent),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: bonusKeys.schedule() });
      toast.success('Modo actualizado');
    },
    onError: () => toast.error('Error al cambiar modo'),
  });
}

export function useForceBonus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bonusApi.forceBonus,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: bonusKeys.schedule() });
      toast.success('Bono forzado');
    },
    onError: () => toast.error('Error al forzar bono'),
  });
}
